import React, { useState, useEffect } from "react";
import Marquee from "react-fast-marquee";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import logo1 from "../assets/logo1.png";
import logo2 from "../assets/logo2.png";
import logo3 from "../assets/logo3.png";
import logo4 from "../assets/logo4.png";
import logo5 from "../assets/logo5.png";

const logos = [logo1, logo2, logo3, logo4, logo5];

const OurClientsMarquee = () => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 1500);
    return () => clearTimeout(timer);
  }, []);

  return (
    <section className="bg-white py-12 overflow-hidden">
      {loading ? (
        <>
          <Skeleton height={36} width={320} className="mb-8 mx-auto" style={{ marginBottom: 32, borderRadius: 8 }} />
          <div className="flex justify-center gap-12">
            {Array.from({ length: 5 }).map((_, idx) => (
              <Skeleton key={idx} className="w-36 h-16 md:w-44 md:h-20 rounded" style={{ width: '9rem', height: '4rem', borderRadius: 8 }} />
            ))}
          </div>
        </>
      ) : (
        <>
          <h2 className="text-center text-2xl md:text-3xl font-bold text-[#003A7D] mb-8">
            Some of our valued clients
          </h2>

          <div className="relative">
            {/* Outer wrapper */}
            <div className="w-full overflow-hidden">
              <Marquee
                gradient={false}
                speed={40}
                pauseOnHover={true}
              >
                {logos.concat(logos).map((logo, index) => (
                  <div
                    key={index}
                    className="flex items-center justify-center w-36 h-16 md:w-44 md:h-20 shrink-0 mx-6"
                  >
                    <img
                      src={logo}
                      alt={`Client ${index + 1}`}
                      className="h-full object-contain"
                    />
                  </div>
                ))}
              </Marquee>
            </div>
          </div>
        </>
      )}
    </section>
  );
};

export default OurClientsMarquee;
